/** Encode file content into a data URI */
export function makeDataUri(content: string): string {
  return `data:text/plain;base64,${btoa(content)}`;
}

/** Decode a file from a data URI */
export function makeFileFromDataUri(fileUrl: string): File {
  const [header, encodedContent] = fileUrl.split(',');

  if (header !== 'data:text/plain;base64' && encodedContent) {
    throw new Error('Invalid file URL');
  }

  const blob = new Blob([atob(encodedContent)], {
    type: 'application/xml',
  });

  const file = new File([blob], 'metadata.xml', {
    type: 'application/xml',
  });

  return file;
}
